
import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col, Modal } from 'reactstrap';

//HELPER FUNCTION
import { convertToRupiah } from "../../../utils";

//ASSET
import CloseIcon from "../../../images/close-button-black.png";

const UserBalanceInfoModal = ({ isOpen, onToggle, cashOutFee, adminFee }) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      modalClassName="modal-seller-credit-info">
      <div onClick={onToggle} className="close-wrapper">
        <KickImage src={CloseIcon} />
      </div>
      <Row>
        <Col>
          <p>What is Seller Credit?</p>
          <p>Seller Credit is a monetary balance from your sales. It can also be used to purchase anything in Kick Avenue. Cash out fee applies.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Cash Out Fee</p>
          <p>{`Cash Out from Seller Credit will be charged with ${cashOutFee}% of total cash out + IDR ${convertToRupiah(parseFloat(adminFee))}.`}</p>
        </Col>
      </Row>
    </Modal>
  )
}

export default UserBalanceInfoModal;